import React from 'react'
import { MenuItems } from '../../enums/MenuItems'
import TopBanner from '../../uiV2/common/layout/topBanner/TopBanner'

type Props = {
    children: React.ReactNode
    activeMenuItem: MenuItems
}

function LayoutSingleView({
    children,
    activeMenuItem,
}: Props): React.JSX.Element {
    return (
        <div className="h-screen flex flex-col">
            <TopBanner activeMenuItem={activeMenuItem} />
            {/* Main Content Area */}
            <div className="max-w-[1040px] w-full pt-[24px] pb-[64px] mx-auto">
                {children}
            </div>
        </div>
    )
}

export default LayoutSingleView
